import { useTranslation } from 'react-i18next';

export default function TrustCards() {
  const { t } = useTranslation();
  const cards = t('trust.cards', { returnObjects: true }) as Array<{ title: string; desc: string }>;

  const icons = ['ri-file-list-3-line', 'ri-grid-line', 'ri-book-open-line', 'ri-shield-check-line'];

  const images = [
    'https://readdy.ai/api/search-image?query=Elegant%20minimalist%20product%20catalog%20spread%20on%20warm%20cream%20desk%2C%20soft%20natural%20light%20from%20left%20window%2C%20clean%20organized%20aesthetic%2C%20terracotta%20and%20beige%20tones%2C%20European%20editorial%20style%2C%20high%20detail%2C%20no%20people%2C%20no%20text&width=600&height=400&seq=trust-updated-1&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Artistic%20arrangement%20of%20diverse%20fashion%20items%20neatly%20organized%20in%20categories%20on%20warm%20neutral%20surface%2C%20soft%20diffused%20daylight%2C%20clean%20minimalist%20retail%20display%2C%20warm%20cream%20and%20sage%20green%20accents%2C%20European%20boutique%20aesthetic%2C%20high%20detail%2C%20no%20people%2C%20no%20text&width=600&height=400&seq=trust-categories-2&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Stylish%20open%20notebook%20with%20handwritten%20product%20notes%20next%20to%20a%20coffee%20cup%20on%20warm%20textile%20background%2C%20soft%20morning%20light%2C%20cozy%20productive%20atmosphere%2C%20warm%20terracotta%20and%20cream%20palette%2C%20European%20lifestyle%20photography%2C%20high%20detail%2C%20no%20people%2C%20no%20text&width=600&height=400&seq=trust-guides-3&orientation=landscape',
    'https://readdy.ai/api/search-image?query=Clean%20modern%20security%20concept%20with%20a%20shield%20symbol%20on%20warm%20beige%20textile%2C%20soft%20natural%20shadows%2C%20trust%20and%20protection%20aesthetic%2C%20minimalist%20design%2C%20warm%20cream%20and%20soft%20sage%20tones%2C%20European%20editorial%20style%2C%20high%20detail%2C%20peaceful%20composition%2C%20no%20people%2C%20no%20text&width=600&height=400&seq=trust-safety-4&orientation=landscape',
  ];

  return (
    <section className="py-14 md:py-20 bg-background-50">
      <div className="max-w-7xl mx-auto px-4 md:px-6">
        <h2 className="text-2xl md:text-3xl font-heading font-bold text-foreground-900 text-center mb-10 md:mb-14">
          {t('trust.title')}
        </h2>
        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-5 md:gap-6">
          {cards.map((card, idx) => (
            <div
              key={idx}
              className="group bg-background-50 border border-background-200/70 rounded-lg overflow-hidden hover:border-accent-300 transition-all duration-200"
            >
              <div className="w-full h-40 md:h-44 overflow-hidden">
                <img
                  src={images[idx]}
                  alt={card.title}
                  className="w-full h-full object-cover object-top group-hover:scale-105 transition-transform duration-300"
                  title={card.title}
                />
              </div>
              <div className="p-5 md:p-6">
                <div className="w-9 h-9 md:w-10 md:h-10 flex items-center justify-center rounded-md bg-accent-100 text-accent-600 mb-3">
                  <i className={`${icons[idx]} text-lg md:text-xl`}></i>
                </div>
                <h3 className="text-base md:text-lg font-heading font-semibold text-foreground-900 mb-2">
                  {card.title}
                </h3>
                <p className="text-sm text-foreground-600 leading-relaxed">
                  {card.desc}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}